function ProfilePage() {
  return (
    <div>Profile</div>
  )
}

export default ProfilePage;